import { useEffect, useState } from 'react'
import { normalizeRoomCode } from '@v2/multiplayer'
import { api, errorMessage } from './network'
import { Page, Wordmark } from './page'

/** An invitation link is just a code. Resolve it and hand off to the table. */
export function JoinByCode({ code }: { code: string }) {
  const [error, setError] = useState<string | null>(null)
  useEffect(() => {
    const normalized = normalizeRoomCode(code)
    if (!normalized) { setError('That invitation link is not valid.'); return }
    void api.resolveCode(normalized).then(found => location.replace(`/play/${found.roomId}`)).catch(cause => setError(errorMessage(cause)))
  }, [code])
  return <Page>
    <header className="pg-masthead"><Wordmark/></header>
    {error ? <div className="pg-card"><p className="pg-error" role="alert">{error}</p><a className="tt-secondary-button" href="/">Back to the start</a></div> : <p className="pg-muted" role="status">Finding your table…</p>}
  </Page>
}
